import {createBrowserHistory} from 'history';
import {persistStore} from 'redux-persist';
import {configureStore} from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
import axios from 'axios';
import persistedReducer from './rootReducer';

export type RootState = ReturnType<typeof appStore.getState>
export type AppStore = ReturnType<typeof createStore>
export type AppDispatch = typeof appStore.dispatch

function createStore() {
  return configureStore({
    reducer: persistedReducer(),
    middleware: [thunk],
  });
}

const appHistory = createBrowserHistory();
const appStore = createStore();
const appPersistor = persistStore(appStore, {}, () => {
  const currentToken = appStore.getState().auth?.token;
  if (currentToken) {
    axios.defaults.headers.common['token'] = `${currentToken}`;
  }
});

export {appPersistor, appHistory, appStore};

